import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon48: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M2.9292 2.92575C6.8281 -0.97525 13.1719 -0.97525 17.0708 2.92575C18.96 4.81475 20 7.32775 20 9.99975C20 12.6718 18.96 15.1848 17.0708 17.0748C15.1216 19.0248 12.5605 19.9998 10 19.9998C7.4395 19.9998 4.8784 19.0248 2.9292 17.0748C1.04 15.1848 0 12.6718 0 9.99975C0 7.32775 1.04 4.81475 2.9292 2.92575ZM10 0.999755C7.6953 0.999755 5.3906 1.87675 3.6362 3.63275C1.936 5.33375 1 7.59375 1 9.99975C1 12.4048 1.936 14.6648 3.6362 16.3658C7.145 19.8778 12.855 19.8778 16.3638 16.3658C18.064 14.6648 19 12.4048 19 9.99975C19 7.59375 18.064 5.33375 16.3638 3.63275C14.6094 1.87675 12.3047 0.999755 10 0.999755ZM14.6509 11.8358C14.7524 11.5778 15.0444 11.4497 15.2998 11.5537C15.5566 11.6557 15.6821 11.9468 15.5806 12.2028C14.6685 14.5078 12.478 15.9958 10 15.9958C7.522 15.9958 5.3311 14.5078 4.4189 12.2028C4.3174 11.9468 4.4429 11.6557 4.6997 11.5537C4.9561 11.4497 5.2471 11.5778 5.3486 11.8358C6.1089 13.7558 7.9346 14.9958 10 14.9958C12.0649 14.9958 13.8906 13.7558 14.6509 11.8358ZM7 5.99576C7.5513 5.99576 8 6.44376 8 6.99576C8 7.54776 7.5513 7.99576 7 7.99576C6.4487 7.99576 6 7.54776 6 6.99576C6 6.44376 6.4487 5.99576 7 5.99576ZM13 5.99576C13.5513 5.99576 14 6.44376 14 6.99576C14 7.54776 13.5513 7.99576 13 7.99576C12.4487 7.99576 12 7.54776 12 6.99576C12 6.44376 12.4487 5.99576 13 5.99576Z"
        fill="#FFD147"
      />
    </Icon>
  )
}
